import { declareString } from "@1js/localization";

export const WorkTabTitle = declareString("promptLibrary.workTab", {
  text: "Work",
  comment:
    "Text which appears on main page for work tab. The Copilot Lab page has different tabs depending on the prompts. Some prompts will be shown un der the Personal tab, others under Work tab. This is a property/kind (adjective)",
});

export const PersonalTabTitle = declareString("promptLibrary.personalTab", {
  text: "Personal",
  comment:
    "Text which appears on main page for personal tab. The Copilot Lab page has different tabs depending on the prompts. Some prompts will be shown un der the Personal tab, others under Work tab.",
});

export const ShowMoreButtonLabel = declareString("promptLibrary.showMore", {
  text: "Show more",
  comment:
    "Button text for loading more prompts. When the user clicks on the button more prompt cards are loaded in the Copilot Lab website.",
});
